// @flow
import * as React from 'react';
import {
    Box, Text, Button,
} from 'grommet';
import { Next, Previous } from 'grommet-icons';
import styled from 'styled-components';

type Props = {
    from: number,
    rowCount: number,
    count: number,
    // Elastic Search returns 10,000 as max results in count, so we need to use total from the response
    total?: number,
    changePage: (page: number) => void,
}

const StyledButton = styled(Button)`
    ${(props) => `
        border-color: ${props.borderColor || props.theme.global.colors.buttonBorder};
        border-width: 1px;
        height: 22px;
        &:hover {
            box-shadow: none;
            ${!props.disabled
        && `background-color: ${props.borderColor || props.theme.global.colors.buttonBorder}`}
        }
    `}
`;

const RecordCount = (props: Props) => {
    const {
        from, rowCount, count, total, changePage,
    } = props;

    const currentPage = (from !== 0 && from !== undefined) ? from / rowCount : 0;
    const fromValid = from || 0;
    let totalCount = count;

    // If we have the max results that we can get from Elastic Search we just show a + sign and the count
    if (count === 10_000) {
        totalCount = `+${count}`;
    } else {
        totalCount = count;
    }

    return (
        <Box
            alignSelf="center"
            direction="row"
        >
            <Box pad={{ horizontal: 'xsmall' }}>
                <StyledButton
                    disabled={fromValid === 0} // first page
                    icon={<Previous size="small" />}
                    plain={false}
                    onClick={() => changePage(currentPage - 1)}
                    size="small"
                />
            </Box>
            {count ? (
                // eslint-disable-next-line max-len
                <Text>{`${fromValid + 1} - ${(count - fromValid) > rowCount ? fromValid + rowCount : count} (${totalCount})`}</Text>
            ) : (
                <Text>0 - 0 (0)</Text>
            )}
            <Box pad={{ horizontal: 'xsmall' }}>
                <StyledButton
                    disabled={(count - fromValid) <= rowCount} // last page
                    icon={<Next size="small" />}
                    plain={false}
                    onClick={() => changePage(currentPage + 1)}
                    size="small"
                />
            </Box>
        </Box>
    );
};

RecordCount.defaultProps = {
    total: 0,
};

export default RecordCount;
